<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.saleorder') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.status == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.status == 'padding'"
                    class="badge badge-warning">{{ $t('status.so.padding') }}</span>
                  <span
                    v-if="query.status == 'rejected'"
                    class="badge badge-danger">{{ $t('status.so.rejected') }}</span>
                  <span
                    v-if="query.status == 'uncompleted'"
                    class="badge badge-info">{{ $t('status.so.uncompleted') }}</span>
                  <span
                    v-if="query.status == 'completed'"
                    class="badge badge-success">{{ $t('status.so.completed') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        class="text-warning"
                        value="padding">
                        {{ $t('status.so.padding') }}
                      </option>
                      <option
                        class="text-danger"
                        value="rejected">
                        {{ $t('status.so.rejected') }}
                      </option>
                      <option
                        class="text-info"
                        value="uncompleted">
                        {{ $t('status.so.uncompleted') }}
                      </option>
                      <option
                        class="text-success"
                        value="completed">
                        {{ $t('status.so.completed') }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.so') }}</th>
              <th class="no-sort">{{ $t('message.customer') }}</th>
              <th class="no-sort">{{ $t('message.productlist') }}</th>
              <th class="no-sort">{{ $t('documents.gi') }}</th>
              <th class="no-sort">{{ $t('documents.in') }}</th>
              <th>{{ $t('message.debttotal') }}</th>
              <th>{{ $t('message.paidtotal') }}</th>
              <th>{{ $t('message.grandtotal') }}</th>
              <th>{{ $t('message.scheduled_at') }}</th>
              <th
                class="no-sort"
                style="max-width: 100px;">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="sales.length === 0"
                colspan="10"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr v-for="(item, index) in sales">
              <td :data-order="item.so_id">
                <router-link-custom
                  :to="{name: 'SaleOrderEdit', query: {
                    so_id: item.so_id,
                    so_code: item.so_code
                  }}"
                  :text="item.so_code"
                  :to_appid="5"
                  :current_appid="5"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.customer"
                  :to="{name: 'ContactCustomerEdit', query: {cus_id: item.customer.customer_id, cus_name: item.customer.customer_name}}"
                  :text="item.customer.customer_name"
                  :to_appid="11"
                  :current_appid="5"
                  :disabled="item.customer.is_deleted == true" />
              </td>
              <td>
                <item-list :orders="item.orders" />
              </td>
              <td style="vertical-align: top;">
                <div v-for="(goodsissue, index_) in item.reference.goodsissues">
                  <router-link-custom
                    :to="{name: 'GoodsIssueEdit', query: {
                      gi_id: goodsissue.gi_id,
                      gi_code: goodsissue.gi_code
                    }}"
                    :text="goodsissue.gi_code"
                    :status="{
                      text: getGoodsIssueStatus(goodsissue, $t).message,
                      color: getColorFormStatus(getGoodsIssueStatus(goodsissue, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="3"
                    :current_appid="5"/>
                </div>
              </td>
              <td style="vertical-align: top;">
                <div v-for="(invoice, index_) in item.reference.invoices">
                  <router-link-custom
                    :to="{name: 'AccountsInvoiceEdit', query: {
                      in_id: invoice.in_id,
                      in_code: invoice.in_code
                    }}"
                    :text="invoice.in_code"
                    :status="{
                      text: getInvoiceStatus(invoice, $t, mixin).message,
                      color: getColorFormStatus(getInvoiceStatus(invoice, $t, mixin).status),
                      type: 'icon'
                    }"
                    :to_appid="12"
                    :current_appid="5"/>
                </div>
              </td>
              <td :data-order="getDebtSaleAmount(item)">
                {{ getNumber(getDebtSaleAmount(item)) }}
              </td>
              <td :data-order="_getPaymentTotal(item.reference.invoices)">
                {{ getNumber(_getPaymentTotal(item.reference.invoices)) }}
              </td>
              <td :data-order="getTotal(item.orders).payment">
                {{ getNumber(getTotal(item.orders).payment) }}
              </td>
              <td :data-order="item.scheduled_at">
                {{ getDate(item.scheduled_at) }}
              </td>
              <td style="max-width: 100px;">
                <template>
                  <span
                    v-if="getSaleStatus(item, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getSaleStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getSaleStatus(item, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getSaleStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getSaleStatus(item, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getSaleStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getSaleStatus(item, $t, mixin).message }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'SaleOrderAll',
  mixins: [userPermissionMixin],
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      sales: 'getSales',
      getSaleStatus: 'getSaleStatus',
      getInvoiceStatus: 'getInvoiceStatus',
      getGoodsIssueStatus: 'getGoodsIssueStatus',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.sales.title'),
      current: {
        app_name: 'sales',
        app_id: 5,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearSales'])
  },
  methods: {
    async updateSaleStatus (data) {
      let res = await this.$store.dispatch('updateSaleStatus', { so_id: data.so_id, status: data.status })
      this.showFinish(this.$Progress)
    },
    _getPaymentTotal (invoices) {
      let total = 0
      invoices.map(inv => {
        inv.reference.payments.map(pe => {
          if (pe.status == 'paid') {
            total += pe.payment.amount
          }
        })
      })
      return total
    },
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getSales', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        status: (() => {
          return this.query.status !== 'all'
            ? this.query.status
            : null
        })(),
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/sales/so/All.vue